import { Box, Tooltip as MuiTooltip } from '@mui/material'
import { isEmpty } from 'lodash'
import { useTranslate } from 'ra-core'
import { FunctionField } from 'react-admin'

import { STATUS_CODES } from '../config/statuses'
import { useCommonStyles } from '../config/theme'
import { getStatusStyles } from '../domain/statuses'

const CodesTooltip = ({ codes }) => {
  const translate = useTranslate()
  return (
    <ul style={{ marginInline: 6, marginBlock: 4, paddingLeft: 8 }}>
      {codes.map((code) => (
        <li key={code} style={{ fontSize: 12, paddingBlock: 3 }}>
          {translate(STATUS_CODES[code])}
        </li>
      ))}
    </ul>
  )
}

const StatusField = ({ source, ...props }) => {
  const commonClasses = useCommonStyles()

  return (
    <FunctionField
      {...props}
      render={(record) => {
        const status = record?.[source]
        if (!status) return null

        const dot = (
          <Box
            sx={{
              backgroundImage: (theme) => getStatusStyles(status, theme).gradient,
              borderRadius: '7px',
              height: '14px',
              width: '14px',
            }}
          />
        )

        const hasCodes = Boolean(status.severity) && !isEmpty(status.codes)

        return (
          <div style={{ ...commonClasses.flexRowCenterContainer, ...commonClasses.center }}>
            {hasCodes ? (
              <MuiTooltip title={<CodesTooltip codes={status.codes} />} placement="right">
                {dot}
              </MuiTooltip>
            ) : (
              dot
            )}
          </div>
        )
      }}
    />
  )
}

export default StatusField
